import { Episode } from "@/types/Episode";
import fetcher_v2 from "../fetcher_v2";
import { QueryOut } from "@/containers/QueryBuilder/requestUtils";
import { URLS } from "../urls";

type PreviewMeta = {
  estimated_mentions: number;
  total_matches: number;
  page_token: number | null;
};

type PreviewResponse = {
  meta: PreviewMeta;
  results: Episode[];
};

type PreviewBody = {
  start_date: string | null;
  end_date: string | null;
  queries: QueryOut[];
  industry: string | null;
};

type QueryFieldErrors = {
  [field: string]: string | string[] | undefined;
};

type ComponentErrors = {
  queries?: QueryFieldErrors[];
  non_field_errors?: string[];
  title?: string;
  search_type?: string;
  start_date?: string;
  end_date?: string;
  sorting_position?: string;
  [extraKey: string]: unknown;
};

export const previewSearch = async (data: PreviewBody) => {
  return fetcher_v2<PreviewResponse, PreviewBody, ComponentErrors>(
    URLS.API_PREVIEW_RESULTS,
    {
      method: "POST",
      body: data,
    }
  );
};
